import { render, staticRenderFns } from "./doubleChannelRecipe.vue?vue&type=template&id=9c52a7d2&scoped=true&"
import script from "./doubleChannelRecipe.vue?vue&type=script&lang=js&"
export * from "./doubleChannelRecipe.vue?vue&type=script&lang=js&"
import style0 from "./doubleChannelRecipe.vue?vue&type=style&index=0&id=9c52a7d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c52a7d2",
  null
  
)

export default component.exports